






























































import Vue from "vue";
import { mapActions, mapState } from "vuex";
import { ProductTabFilterOptions } from "@/types";
import TableControls from "./TableRenderers/TableControls.vue";
import NameRenderer from "./TableRenderers/NameRenderer.vue";
import { ATable } from "@canvas/componentlibrary";
export default Vue.extend({
  name: "manage-products",
  components: {
    TableControls,
    NameRenderer,
    ATable,
  },
  data() {
    return {
      productTabItems: ProductTabFilterOptions,
      tableFilters: {
        activeTab: ProductTabFilterOptions[0].key,
      },
    };
  },
  props: {
    rows: {
      type: Array,
    },
    columns: {
      type: Array,
    },
    title: {
      type: String,
    },
    page: {
      type: Number,
    },
    pagelength: {
      type: Number,
    },
    pagecount: {
      type: Number,
    },
    sortorder: {
      type: String,
    },
    sortby: {
      type: String,
    },
    isDateFilterRequired: {
      type: Boolean,
      default: false,
    },
    datefilter: {
      type: Object,
    },
    isTableControlsRequired: {
      type: Boolean,
      default: true,
    },
    tableType: {
      type: String,
    },
  },
  computed: {
    ...mapState("uiModule", {
      modalElement: "modalElement",
      isOnMobileDevice: "isOnMobileDevice",
    }),
  },
});
